import React from 'react';

import { Specification } from 'src/components/ProductDetail/utils/product-detail.types';

type SpecificationsProps = {
    specifications: Specification[];
};

export function Specifications(props: SpecificationsProps) {
    return (
        <table role="table">
            <tbody>
                {props.specifications.map((spec) => {
                    return (
                        <tr key={spec.label}>
                            <th>{spec.label}</th>
                            <td>{spec.value}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
